import React, { useEffect, useState } from "react";
import "./WaitingApproval.css";
import { db, auth } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function WaitingApproval() {
  const [approved, setApproved] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let unsubSnap = () => {};

    const unsubAuth = onAuthStateChanged(auth, (user) => {
      if (!user) {
        navigate("/", { replace: true });
        return;
      }

      unsubSnap = onSnapshot(doc(db, "vendors", user.uid), (docSnap) => {
        if (!docSnap.exists()) {
          navigate("/", { replace: true });
          return;
        }

        const data = docSnap.data();

        if (data.paymentStatus !== "submitted" && data.paymentStatus !== "approved") {
          navigate("/vendor-payment", { replace: true });
          return;
        }

        if (data.approvalStatus === "rejected") {
          alert("Your vendor application was rejected. Please contact support.");
          navigate("/", { replace: true });
          return;
        }

        if (data.approvalStatus === "approved") {
          setApproved(true);
          setTimeout(() => {
            navigate("/vendor-idcard", { replace: true });
          }, 2000);
        }
      });
    });

    return () => {
      unsubAuth();
      unsubSnap();
    };
  }, [navigate]);

  return (
    <div className="waiting-container">
      <div className="waiting-card">
        {!approved ? (
          <>
            <div className="icon">⏳</div>
            <h2 className="title">Waiting for Approval</h2>
            <p className="desc">Your vendor account is under review. Please wait...</p>
            <div className="loader"></div>
          </>
        ) : (
          <>
            <div className="icon success">✅</div>
            <h2 className="title">Approved!</h2>
            <p className="desc">Your account is now active. Redirecting...</p>
          </>
        )}
      </div>
    </div>
  );
}
